/* eslint-disable */
import React from 'react'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import {Link} from 'react-router-dom'
import {ModalBody} from 'mdbreact'
import {Checkbox, message} from 'antd'
import JASPERREPORT from '../BaseComponent/JASPERREPORT'
import http from '../Interceptor/Interseptor'
import REPORT_RETAIL from '../BaseComponent/REPORTRETAIL'
import cookie from 'react-cookies'
import WAREHOUSE from '../BaseComponent/WAREHOUSE'
import SortLocal from '../BaseComponent/sortLocal'
import Loader from '../loaders/loader'
import {Helmet} from 'react-helmet'

class WarehouseLink extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      date: '',
      showPrintLink: '',
      hasUnmatch: '',
      preRecordId: '',
      providerId: '',
      providerName: '',
      manualRegVal: null,
      selectedDate: null,
      selectedOption: null,
      providerValue: '',
      providers: [],
      refFactorVal: moment(),
      typeWarehouseId: '',
      isInput: '',
      isInternal: false,
      refWarehouseId: '',
      id: '',
      code: '',
      quantity: '',
      product: [],
      details: [],
      wareHousesname: [],
      docType: [],
      errorDocForm: '',
      addError: '',
      valueBarcode: 'barcodeOnly',
      fadeTable: 'true',
      visible: false,
      searchesProduct: [],
      search: '',
      searchTablevisibility: false,
      pageNumber: 1,
      lengthProducts: 0,
      docNum: '',
      modal: false,
      preRecordInfo: {},
      array: [],
      errorForm: {
        warehouseName: '',
        isInputError: '',
        warehouseTypeError: ''
      },
      docArr: [],
      allDocTypes: [],
      modalError: false,
      unMatchProduct: [],
      errorTextModal: 'آیا از ثبت نهایی پیش سند مطمئن هستید؟؟',
      description: '',
      receiverName: '',
      senderName: '',
      refTypeWarehouseName: '',
      manReg: '',
      checked: false,
      typeDocId: '',
      confirmDate: '',
      recorderPerson: '',
      internal: false,
      abnormal: false,
      proText: '',
      sortData: [
        {
          name: 'ردیف',
          value: 'id',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'کدمحصول',
          value: 'articleId',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'بارکد محصول',
          value: 'productCode',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'نام محصول',
          value: 'productName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'تامین کننده',
          value: 'providerName',
          sorted: false,
          direction: null,
          sortable: true
        },
        {
          name: 'واحد',
          value: 'unit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تاریخ تولید',
          value: 'unit',
          sorted: false,
          direction: null,
          sortable: false
        },
        {
          name: 'تعداد',
          value: 'quantity',
          sorted: false,
          direction: null,
          sortable: true
        }
      ],
      sort: {},
      deliveryDates: []
    }
  }
  componentDidMount() {
    document.title = 'Your page title here'
    let urlParams = new URLSearchParams(window.location.search)
    let showPrintLink = urlParams.get('showPrintLink') === null ? '' : urlParams.get('showPrintLink')
    let hasUnmatch = urlParams.get('hasUnmatch') === null ? '' : urlParams.get('hasUnmatch')
    let preRecordId = urlParams.get('preRecordId') === null ? '' : urlParams.get('preRecordId')
    let providerId = urlParams.get('providerId') === null ? '' : urlParams.get('providerId')
    let date = urlParams.get('date') === null ? '' : urlParams.get('date')
    let deliveryDates = urlParams.get('deliveryDates') === null ? '' : urlParams.get('deliveryDates')
    if (deliveryDates === '') {
      this.setState({
        deliveryDates: []
      })
    } else {
      this.setState({
        deliveryDates: deliveryDates.split(',')
      })
    }
    this.setState(
      {
        date,
        showPrintLink,
        hasUnmatch,
        preRecordId,
        providerId,
        loading: true
        // deliveryDates: array
      },
      () => {
        this.getPreRecord(this.state.preRecordId).then(() => {
          this.setState({
            loading: false
          })
        })
        // http.get(`${REPORT_RETAIL.REPORT_RETAIL_LIST_PROVIDER}`, {}).then((response) => {
        //     if (response.data.error == null) {
        //         let res = response.data.object
        //         let findProvider = res.find(item => +item.providerId === +this.state.providerId)
        //         if (findProvider) {
        //             this.setState({
        //                 providerName: findProvider.title
        //             }, () => {
        //             })
        //         }
        //     }
        // }).catch(() => {
        // });
      }
    )
  }

  getPreRecord = (preRecordId) => {
    let data = {
      docId: preRecordId
    }
    return http
      .post(`${WAREHOUSE.WAREHOUSE_DOCUEMNT_GET_DOCUMENT}`, data, {})
      .then((response) => {
        this.setState({
          preRecordInfo: response.data.object,
          product: this.sortByKey(response.data.object.detailEntities, 'rowNo'),
          manualReg:
            response.data.object.manualRegisterDate == null ? undefined : response.data.object.manualRegisterDate,
          refFactor: response.data.object.refFactorDate == null ? undefined : response.data.object.refFactorDate,
          isInput: response.data.object.input,
          typeWarehouseId: response.data.object.typeWarehouseId,
          providerId: response.data.object.providerId,
          wareText: response.data.object.typeWarehouseName,
          docTypeText: response.data.object.typeDocName,
          refWareText:
            response.data.object.refTypeWarehouseName == null ? '-' : response.data.object.refTypeWarehouseName,
          proText: response.data.object.providerName === null ? '' : response.data.object.providerName,
          description: response.data.object.description,
          receiverName: response.data.object.receiverName,
          senderName: response.data.object.senderName,
          providerName: response.data.object.providerName,
          refTypeWarehouseName: response.data.object.refTypeWarehouseName,
          manReg: response.data.object.manualRegisterDate,
          checked: response.data.object.internal,
          internal: response.data.object.internal,
          refWarehouseId: response.data.object.refTypeWarehouseId,
          typeDocId: response.data.object.typeDocId,
          refFactorNo: response.data.object.refFactorNo,
          recorderPerson: response.data.object.recorderPerson,
          abnormal: response.data.object.abnormal
        })
        //
        // const {product} = this.state;
        //
        // for (let i = 0; i < product.length; i++) {
        //     let details = {
        //         id: product[i]['stockProductId']
        //         ,
        //         quantity: Number(product[i]['quantity'])
        //     };
        //     let detailsArray = [];
        //
        //     detailsArray.push(details);
        //
        //     this.setState((prevState) => ({
        //         details: [...prevState.details, details]
        //     }))
        // }
      })
      .catch((error) => {
        alert(JSON.stringify(error))
      })
  }
  epochFrom1 = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    if (n >= 0) {
      return fromEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return fromEpoch - 3.5 * 3600 * 1000
    } else {
      return fromEpoch - 3.5 * 3600 * 1000
    }
  }
  epochTo1 = (x) => {
    var concatDayMount = x.split('/')
    var concatDate = concatDayMount[1] + concatDayMount[2]
    var constantDate = '0631'
    var n = concatDate.localeCompare(constantDate)

    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    if (n >= 0) {
      return toEpoch - 3.5 * 3600 * 1000
    } else if (n < 0 && concatDate === '0101') {
      return toEpoch - 3.5 * 3600 * 1000
    } else {
      return toEpoch - 3.5 * 3600 * 1000
    }
  }

  getDriverOfProduct() {
    let manualRegisterDate = this.state.date
    let providerId = this.state.providerId
    if (providerId === '') {
      message.error('تامین کننده باید انتخاب شده باشد')
    } else if (manualRegisterDate === '') {
      message.error('تاریخ دستی سند باید وارد شده باشد')
    } else {
      JASPERREPORT(
        `report/jasper/dispatch/driver/products/invoice/cart?&providerId=${providerId}&providerName=${
          this.state.providerName
        }&fromTime=${this.epochFrom1(manualRegisterDate)}&toTime=${this.epochTo1(manualRegisterDate)}`
      )
    }
  }
  exportPrint = () => {
    var css = '@page { size:A4 portrait;margin:1mm !important;}',
      head = document.head || document.getElementsByTagName('head')[0],
      style = document.createElement('style')

    style.type = 'text/css'
    style.media = 'print'

    if (style.styleSheet) {
      style.styleSheet.cssText = css
    } else {
      style.appendChild(document.createTextNode(css))
    }

    head.appendChild(style)
    this.setState({
      printDate: jMoment().format('jYY/jMM/jDD HH:mm')
    })
    setTimeout(() => {
      window.print()
    }, 2000)
  }

  sortByKey = (array, key) => {
    return array.sort(function(a, b) {
      var x = a[key]
      var y = b[key]
      return x < y ? -1 : x > y ? 1 : 0
    })
  }

  render() {
    var initialVal = 0
    var sumProduct = this.state.product.reduce(function(acc, current) {
      return Number(acc) + Number(current.quantity)
    }, initialVal)

    return (
      <div className="sanad rtl">
        <Helmet>
          <meta charSet="utf-8" />
          <title>{this.state.proText + ' - ' + ' پیش سند شماره :‌  ' + this.state.preRecordId}</title>
        </Helmet>
        <Loader show={this.state.loading} />
        {/*<AdminMenu/>*/}
        <div className="printDocWrapp printSection" style={{position: 'relative'}}>
          <div className="headerDocWrapp">
            <div className="headerDoc">
              <figure className="rightPrintInfo">
                <p>
                  <span className="boldPrint">شماره پیش سند :</span>
                  <span className="valuePrint">{this.state.preRecordId}</span>
                </p>
                <p>
                  <span className="boldPrint">تاریخ ثبت :</span>
                  <span className="valuePrint">{this.state.registerDate}</span>
                </p>
                <p>
                  <span className="boldPrint">تاریخ دستی سند :</span>
                  <span className="valuePrint">
                    {this.state.manualReg == null ? '' : jMoment(this.state.manualReg).format('jYYYY/jMM/jDD')}
                  </span>
                </p>
              </figure>
              <figure className="rightHeaderDoc">
                <img className="printLogoDoc" src={require('../../image/branding/logo-mini.svg')} alt="" />
                <h4>پیش سند {this.state.isInput ? 'وارده' : 'صادره'}</h4>
                <h4>انبار {this.state.wareText}</h4>
                {/*<h4>{this.props.match.params.natureDocNo}</h4>*/}
              </figure>
              <figure className="leftPrintInfo">
                <p>کاربر چاپ پیش سند : {cookie.load('name')}</p>
                <p>{'تاریخ چاپ : ' + this.state.printDate}</p>
                {/*<p>کاربر ثبت کننده سند : {this.state.recorderPerson}</p>*/}
              </figure>
            </div>
          </div>
          <div className="bodyDocPrint">
            <div className="itemBodyPrintDoc">
              <figure>
                <p>
                  <span className="boldPrint">نام انبار : </span>
                  <span className="valuePrint">{this.state.wareText}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint">بین انبار : </span>
                  <span className="valuePrint">{this.state.checked ? 'هست' : 'نیست'}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> انبار طرف : </span>
                  <span className="valuePrint">{this.state.refTypeWarehouseName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> ماهیت : </span>
                  <span className="valuePrint">{this.state.isInput ? 'وارده' : 'صادره'}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تحویل دهنده : </span>
                  <span className="valuePrint">{this.state.senderName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تاریخ فاکتور طرف : </span>
                  <span className="valuePrint">
                    {this.state.refFactor == null ? '' : jMoment(this.state.refFactor).format('jYYYY/jMM/jDD')}
                  </span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تامین کننده : </span>
                  <span className="valuePrint">{this.state.providerName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> نوع سند : </span>
                  <span className="valuePrint">{this.state.docTypeText}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> تحویل گیرنده : </span>
                  <span className="valuePrint">{this.state.receiverName}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> شماره فاکتور : </span>
                  <span className="valuePrint">{this.state.refFactorNo}</span>
                </p>
              </figure>
              <figure>
                <p>
                  <span className="boldPrint"> سند اصلاحی : </span>
                  <span className="valuePrint">{this.state.abnormal ? 'هست' : 'نیست'}</span>
                </p>
              </figure>
            </div>
            <div className="descriptionDoc">
              <p>توضیحات سند : {this.state.description}</p>
            </div>
          </div>
          <table className="printTable printDocTable">
            <thead>
              <tr>
                <td>
                  <div className="page-header-space" />
                </td>
              </tr>
            </thead>

            <tbody>
              <tr className="firstRow">
                <th>ردیف</th>
                <th>کد محصول</th>
                <th>بارکد محصول</th>
                <th>نام محصول</th>
                <th>تامین کننده</th>
                <th>واحد</th>
                <th>تاریخ تولید</th>
                <th>تعداد</th>
              </tr>
              {this.state.product.map((items, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{items.stockProductId}</td>
                  <td>{items.productCode}</td>

                  <td>
                    <span target="_blank" className="text-decoration-none">
                      {items.productName}
                    </span>
                  </td>
                  <td>{items.providerName}</td>
                  <td>{items.productUnitTitle}</td>
                  <td>{items.manufactureDate}</td>
                  <td>{items.quantity}</td>
                </tr>
              ))}
              <tr>
                <td colSpan={7}>جمع اقلام کالا</td>
                <td>{sumProduct}</td>
              </tr>
              <tr>
                <td className="signatureCell" rowSpan={3} colSpan={8}>
                  <div className="signatureDoc">
                    <figure>
                      <p>امضای تحویل دهنده : </p>
                    </figure>
                    <figure>
                      <p>امضای تحویل گیرنده : </p>
                    </figure>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div className="wrapperIframe">
          <ul className="breadcrumb">
            <li>
              <Link to={'/search'}>به روزرسان</Link>
            </li>
            <li>انبار</li>
            <li>لینک های انبار</li>
          </ul>
          <div className="container-fluid py-4 bg-white">
            <div className="row flex-column justify-content-center align-item-center align-content-center">
              <div className="col-6">
                <h4 className="font-weight-bold text-center">{'پیش سند شماره : ' + this.state.preRecordId}</h4>
                <h4 className="font-weight-bold text-center">{' تامین کننده : ' + this.state.proText}</h4>
                <h4 className="font-weight-bold">
                  {/*{this.state.hasUnmatch === 'true' && <a className='btn btn-lg btn-info btn-block' href={'/ShowPreRecord/' + this.state.preRecordId} target='_blank'>چاپ</a>}*/}
                  {this.state.hasUnmatch === 'false' && (
                    <button className="btn btn-primary btn-block" onClick={this.exportPrint}>
                      چاپ
                    </button>
                  )}
                </h4>
              </div>
              <div className="col-6">
                <h4 className="font-weight-bold">
                  <a
                    className="btn btn-lg btn-success btn-block"
                    href={`/orderList?providerId=${this.state.providerId}&hasUnmatch=${this.state.hasUnmatch}&date=${
                      this.state.date
                    }`}
                    target="_blank"
                  >
                    گزارش وضعیت سفارشات
                  </a>
                </h4>
              </div>
              <div className="col-6">
                <button className="btn btn-info btn-block jasperBtn" onClick={this.getDriverOfProduct.bind(this)}>
                  {' '}
                  گزارش کالای جایگاه به تفکیک فاکتور
                </button>
              </div>
              {this.state.deliveryDates.length > 0 && (
                <div className="col-6 my-3">
                  <p>تاریخ‌(های) تحویل مشتری</p>
                  <table className="baseTable">
                    <tr className="firstRow">
                      <td>ردیف</td>
                      <td>تاریخ تحویل</td>
                    </tr>
                    {this.state.deliveryDates.map((item, index) => (
                      <tr>
                        <td>{index + 1}</td>
                        <td>{jMoment(+item).format('jYYYY/jMM/jDD')}</td>
                      </tr>
                    ))}
                  </table>
                </div>
              )}
            </div>
          </div>
          <p className="errorText" id="errorText" />
        </div>
      </div>
    )
  }
}

export default WarehouseLink
